// Import order matters: launch reads tgWebAppStartParam from window.location, and
// initTelegram() reloads the page and strips the launch params from the URL.
import { initialLaunchIntent } from './launch';
import { markDevBuild } from './buildBadge';
import { getInitDataRaw, initTelegram } from './telegram';
import { initTracking } from './tracking';
import { revealFocus } from './reveal';
import { followViewport } from './viewport';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import Boundary from './screens/Boundary';
// The faces are declared and bundled in index.css — not pulled from a CDN: the
// mini app opens on mobile data, and a font that arrives late or never leaves
// the system one standing in for it.
import './index.css';

// Before anything that can throw. ADR-0010: the handlers are attached synchronously so
// that a failure in the first frame is still reported, even while the transport loads.
initTracking();

initTelegram();
// Before the first render: the shell is sized off `--app-h`, and a frame drawn
// against the fallback is a frame of the whole app at the wrong height.
followViewport();
// After it, and the order is the whole of why: what this scrolls a field into
// is the box `followViewport` has just written.
revealFocus();
markDevBuild();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Boundary>
      <App launchIntent={initialLaunchIntent} getInitDataRaw={getInitDataRaw} />
    </Boundary>
  </StrictMode>,
);
